// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles-module__sectionContainer___dlpJc {\n  padding: 1.75rem 2rem;\n  display: flex;\n  flex-direction: column;\n}\n", "",{"version":3,"sources":["webpack://screens/business-profile-page/components/owner-profile-page/components/business-info-section/styles.module.less"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;AACF","sourcesContent":[".sectionContainer {\n  padding: 1.75rem 2rem;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionContainer": "styles-module__sectionContainer___dlpJc"
};
export default ___CSS_LOADER_EXPORT___;
